module.exports = __webpack_public_path__ + "d6d31cb1326b7ac03c529d7efa096a2a.pdf";